import * as Sentry from '@sentry/react';
import { AxiosResponse } from 'axios/index';
import { call, put, takeEvery } from 'redux-saga/effects';
import { AppConfig } from '../../config/appConfig';
import configAPI from '../http/config-api';
import { configLoaderActions } from './config-loader-slice';

function* fetchConfig() {
  try {
    const response: AxiosResponse<AppConfig> = yield call(configAPI.getConfig);

    yield put(configLoaderActions.fetchConfigSuccess({ appConfig: response.data }));
  } catch (error) {
    Sentry.captureException(error);
    yield put(configLoaderActions.fetchConfigError());
  }
}

function* configLoaderSaga() {
  yield takeEvery(configLoaderActions.fetchConfig.type, fetchConfig);
}

export default configLoaderSaga;
